import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Link } from "../../utils/customLink";

import Image from "../../components/image";

import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";
import ArrowRightBigIcon from "../../images/icons/arrow-right-big-icon.inline.svg";

const AlumniSection = () => {
  const { page } = useStaticQuery(graphql`
    query {
      page: wpPage(slug: { eq: "home-page" }) {
        ...HomepageFriendsThatBecomeFamilyFragment
      }
    }
  `);

  const ftbfTitle =
    page?.acfFriendsThatBecomeFamily?.ftbfTitle ?? "Friends that become family";
  const ftbfDescription =
    page?.acfFriendsThatBecomeFamily?.ftbfDescription ??
    `We cannot change the world by ourselves.\n
      That’s why community is at the heart of what we do at GVI. We bring together like-minded people bound by a shared mission. This bond is our greatest strength.
      The people you meet, the values you share, the work you do, the friendships you forge, and the adventures you have together not only have the power
      to change your life – but to change the world.`;

  const ftbfCtaTitle =
    page?.acfFriendsThatBecomeFamily?.ftbfCtaTitle ?? "Find a program";
  const ftbfCtaDestination =
    page?.acfFriendsThatBecomeFamily?.ftbfCtaDestination ?? "programs";
  const ftbfGallery = page?.acfFriendsThatBecomeFamily?.ftbfGallery ?? "";

  const firstGalleryImage = ftbfGallery && ftbfGallery[0] ? ftbfGallery[0] : "";
  const secondGalleryImage =
    ftbfGallery && ftbfGallery[1] ? ftbfGallery[1] : "";

  // console.debug("page?.acfFriendsThatBecomeFamily", ftbfGallery);

  return (
    <section id={"alumni-section"} key={"alumni-section"} className="!min-h-0">
      <div className="w-full flex flex-col-reverse md:flex-row">
        <div className="w-full md:w-5/12 flex py-7 md:py-14">
          <div className="w-11/12 md:w-7/12 mx-auto">
            <div className="md:pl-10">
              <h1 className="w-7/12 md:w-auto font-light leading-9">
                {ftbfTitle}
              </h1>
              <div
                className="py-5 text-black-lighter planet:text-gray-generic text-mob md:text-base"
                dangerouslySetInnerHTML={{
                  __html: ftbfDescription
                }}
              />
              <Link
                to={ftbfCtaDestination}
                className="flex items-center justify-center gap-3 p-2 w-full md:w-8/12
            rounded-full planet:rounded-sm border border-black-lighter planet:border-white 
            font-bold text-black-lighter planet:text-white"
              >
                {ftbfCtaTitle}
                <ArrowRightBigIcon className="fill-black-lighter block planet:hidden" />
                <ArrowRightIcon className="stroke-white hidden planet:block" />
              </Link>
            </div>
          </div>
        </div>

        <div className="w-full md:w-7/12 grid grid-rows-2 grid-cols-8 overflow-hidden">
          <Image
            imageAlt={""}
            image={firstGalleryImage}
            imageClass="w-full h-full !hidden md:!block object-cover object-center row-span-full col-span-3"
            sourceUrl={firstGalleryImage?.sourceUrl}
          />

          <Image
            imageAlt={""}
            image={secondGalleryImage}
            imageClass="w-full md:w-full object-cover object-center col-span-full row-span-1 sm:col-start-4"
            sourceUrl={secondGalleryImage?.sourceUrl}
          />
          <div className="grid grid-flow-col sm:col-start-4 col-span-full">
            {ftbfGallery &&
              ftbfGallery?.slice(2, 4).map((galleryItem, idx) => {
                if (idx < 2)
                  return (
                    <Image
                      key={`gallery-${idx}`}
                      imageAlt={""}
                      image={galleryItem}
                      imageClass="w-full object-cover object-center"
                      sourceUrl={galleryItem?.sourceUrl ?? galleryItem?.type}
                    />
                  );
              })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AlumniSection;
